import React, { Component } from "react";
import burgerIcon from "./menu.svg";
import { USERURL } from '../../constant';

import {Helmet} from "react-helmet";


class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      authe: false,
      logged_user_name: "",
      login_path: window.location.pathname == '/' ? '/login' : '/login'
    };
  }
  componentDidMount() {
    console.log('window.location.pathname', window.location.pathname);
    let logged = localStorage.getItem("authentication");
    let auth_data = JSON.parse(localStorage.getItem("user_data"));
    console.log("auth_data", typeof logged);
    if (auth_data) {
      this.setState({
        authe: logged == "true" ? true : false,
        logged_user_name: auth_data.user_name,
      });
    }
  }
  logoutSess(e) {
    localStorage.clear();
    setTimeout(function () {
      window.location = "/";
    }, 1000);
  }
  render() {


    return (
             
       
        <div className="row menu-vendor" id="navbarText">
          <div className="col-sm-2">
            <a href={USERURL} target="_blank">
              <img className="logo-img" src="assets/images/bewiselogo.png" /></a>
          </div>
          {/* <div className="col-sm-8 search-form">
            <input
              className="form-control"
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
          </div> */}
          <div className="col-sm-10 text-right navbar-text-logo header-rightside">
            {this.state.authe === false ? (
              <a href={this.state.login_path} style={{ color: "black" }}>
                SIGN IN
                {/* <img src={burgerIcon} /> */}
              </a>
            ) : (
              <span style={{ cursor: "pointer" }} onClick={() => this.logoutSess()}>
                SIGN OUT
              </span>
            )}
            {/* <a href="./SignUp" className="btn blue-btn">
              SIGN UP
            </a> */}
          </div>
        </div>
       
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Login/Header.js